import { useMemo } from 'react'
import random from 'lodash/random'

import { useAppDispatch, useAppSelector } from 'common/hooks/redux'
import { hideRightPanel } from 'features/unifiedFlow/store/unifiedFlowSlice'

import RightPanel from '../../components/layout/RightPanel'

import SentimentAnalysisChart from './sentimentAnalysis/SentimentAnalysisChart'
import InsightsCard from './InsightsCard'

const RightSection = () => {
  const dispatch = useAppDispatch()

  const rightPanelVisibility = useAppSelector(
    (state) => state.unifiedFlow.rightPanelVisibility
  )

  const variantsCount = useMemo(() => random(1543, 2018), [])

  return (
    <>
      {rightPanelVisibility !== 'none' && (
        <RightPanel
          scrollableParentId="main-content-page"
          onOutsideClick={() => dispatch(hideRightPanel())}
          visibility={rightPanelVisibility}
        >
          <SentimentAnalysisChart
            isLoading={false}
            selectedSentiment={undefined}
            // TODO HH-4888 The temporary data and structure will change in subsequent tasks.
            series={[
              {
                name: 'impressed',
                value: 3.8717758439845764,
              },
              {
                name: 'helpful',
                value: 4.82272724654644,
              },
              {
                name: 'curious',
                value: 7.167555549191314,
              },
              {
                name: 'excited',
                value: 3.884302308676844,
              },
              {
                name: 'surprising',
                value: 5.08520559216145,
              },
              {
                name: 'appreciative',
                value: 5.587605845790385,
              },
              {
                name: 'urgent',
                value: 2.58,
              },
            ]}
            onClickSentiment={() => {}}
          />

          <div className="p-6 text-coolGray-800">
            <div className="text-xl font-medium mb-3 leading-7">Insights</div>

            <InsightsCard
              title="Phrasee generation"
              content={
                <>
                  Our Language Learning Model generated {variantsCount} unique
                  variants from your brief. Then our Neural Network ranks the
                  variants and selects which should be used based on an
                  optimized experimental design.
                </>
              }
            />
            <InsightsCard
              hasOutline={true}
              title="Experiment design"
              content={
                <>
                  Each optimization experiment is specifically designed to
                  maximize potential uplift and ongoing learnings.
                  <br />
                  Any changes you make to the selected variants will have an
                  effect on the outcome of the experiment.
                </>
              }
            />
            <InsightsCard
              variant="highlighted"
              hasOutline={true}
              title="Performance"
              content={
                <div className="flex items-end">
                  <p className="text-xs">
                    <span>In</span> <b className="text-sm">64%</b>
                    <span>
                      {' '}
                      of experiments the winning variant is within the lines
                      predicted to perform well.
                    </span>
                  </p>
                </div>
              }
            />
            <InsightsCard
              variant="highlighted"
              hasOutline={true}
              title="Exploration"
              content={
                <>
                  By testing new and diverse language variants and features
                  you’re more likely to find high-performing language.
                </>
              }
            />
            <InsightsCard
              hasOutline={true}
              title="Baseline"
              content={
                <>
                  To avoid confirmation bias it’s important to retest variants
                  and features that have performed sub-optimally in previous
                  experiments.
                </>
              }
            />
          </div>
        </RightPanel>
      )}
    </>
  )
}

export default RightSection
